import React from 'react';
import { useTranslation } from 'react-i18next';
// Externals
import PropTypes from 'prop-types';
// Material helpers
import { withStyles } from '@material-ui/core/styles';
// Shared layouts
import DashboardLayout from 'layouts/Dashboard';
import UserNotification from '../Dashboard/components/UserNotification';
import CompareObjectives from '../Dashboard/components/CompareObjectives';
import { Box } from '@material-ui/core';
import { useObjectivesList } from '../../hooks/useObjectivesList';
import { AtCircularProgress } from '../../components/AtCircularProgress';
import { Alert } from '@material-ui/lab';

// Component styles
const styles = (theme) => ({
  root: {
    backgroundColor: '#e7e7e7',
    height: '100%',
  },
  item: {
    height: '100%',
  },
});

export function ComparisonObjectives() {
  const { data, isLoading, isError } = useObjectivesList({
    fromStorage: false,
  });
  const { t } = useTranslation();
  return (
    <>
      <UserNotification />
      <DashboardLayout
        title={t('comparisonObjectives.title')}
        callbackFromParent={() => {}}
        isFirstTime={true}
      >
        <Box className={styles.root}>
          {isLoading && (
            <AtCircularProgress message={t('comparisonObjectives.loading')} />
          )}
          {!isLoading && !isError ? <CompareObjectives params={data} /> : null}
          {isError && (
            <Alert severity="error">{t('comparisonObjectives.errorLoad')}</Alert>
          )}
        </Box>
      </DashboardLayout>
    </>
  );
}

ComparisonObjectives.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ComparisonObjectives);
